<template>
  <div>
    <v-container fluid grid-list-xl class="margin-top-50px">
      <v-layout row>
        <v-flex xs12 xl12 md12 sm12 lg12 class="mt-4">
          <div class="title text-xs-center form-divider margin-top-50px">
            <h2 color="indigo darken-2" large outline flat>ثبت نماینده فروش</h2>
          </div>
        </v-flex>
      </v-layout>
      <v-form ref="NewSystemUserForm" v-model="NSUFvalid" lazy-validation class="margin-top-40px">
        <v-layout row wrap>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.name"
              :rules="nameRules"
              solo
              placeholder="نام و نام خانوادگی"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.no"
              :rules="idRules"
              solo
              placeholder="شماره شناسنامه"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.codeMelli"
              :rules="nationalCodeRules"
              solo
              placeholder="کد ملی"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              mask="##########"
              clearable
              required
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.phone"
              solo
              placeholder="تلفن همراه"
              class="ltr"
              mask="###-###-####"
              hint="لطفا شماره تلفن همراه را بدون صفر وارد نمایید"
              append-icon="call"
              clearable
              required
              :rules="userTelRules"
            ></v-text-field>
          </v-flex>-->

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.phone"
              :rules="userTelRules"
              mask="phone"
              solo
              class="text-xs-left"
              prepend-inner-icon="call"
              style="direction: ltr"
              prefix="+98"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.email"
              solo
              placeholder="پست الکترونیکی "
              class="ltr"
              mask
              hint="yourname@example.com"
              append-icon="email"
              clearable
              :rules="userEmailRules"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.username"
              solo
              placeholder="نام کاربری"
              class="ltr"
              append-icon="verified_user"
              clearable
              hint="نام کاربری باید فقط شامل حروف و اعداد انگلیسی باشد"
              required
              :rules="userNameRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.password"
              solo
              placeholder="رمز عبور"
              class="ltr"
              append-icon="verified_user"
              clearable
              hint="رمز عبور باید فقط شامل حروف و اعداد انگلیسی باشد"
              required
              :rules="userNameRules"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.nfcCount"
              :rules="ncRules"
              solo
              placeholder="تعداد کارت NFC وارد کنید"
              append-icon="credit_card"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.startNumber"
              solo
              placeholder=" شروع شماره "
              class="ltr"
              append-icon="verified_user"
              hint="شماره شروع باید کمتر از شماره پایان باشد"
              :rules="numRules"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-text-field
              v-model="User.endNumber"
              solo
              placeholder="پایان شماره"
              class="ltr"
              append-icon="verified_user"
              hint="شماره پایان باید بیشتر از شماره شروع باشد"
              :rules="numRules"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <!-- <v-text-field v-show='false' type="file" ref="file" v-model="DRVIMAGE"
                                    style="display: none" solo placeholder="عکس" prepend-inner-icon="add_a_photo"
                                    class="ltr">
            </v-text-field>-->
            <input type="file" ref="file" @change="onFileChanged" style="display: none" />
            <v-btn @click="$refs.file.click()" class="white lighten-1 ml-4 bt" style="width: 100%">
              <v-icon>add_a_photo</v-icon>
            </v-btn>
          </v-flex>

          <v-flex xs12 sm6 md6 xl4 lg4>
            <v-btn
              block
              color="indigo"
              class="bt"
              dark
              :loading="userRegisterLoading"
              @click="create(User)"
            >
              <v-icon>done</v-icon>ثبت
            </v-btn>
            <div class="danger-alert" v-if="error">{{error}}</div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import axios from "axios";

import AgentService from "@/services/AgentServices";
export default {
  data() {
    return {
      error: null,
      enabledUsers: [],
      User: {
        name: null,
        no: null,
        codeMelli: null,
        phone: null,
        email: null,
        username: null,
        password: null,
        image: null,
        nfcCount: null,
        startNumber: null,
        endNumber: null
      },
      NSUFvalid: false,
      userRegisterLoading: false,
      userDataTableLoading: false,
      userDeletedDataTableLoading: true,
      UserTableDeletedItem: [],
      confirmRecovery: false,
      idRules: [v => !!v || " شماره شناسنامه ضروری است"],
      nationalCodeRules: [
        v => !!v || "کد ملی فیلد ضروری است",
        v => (v && v.length == 10) || "کد ملی باید ده رقمی باشد"
      ],
      numRules: [v => !!v || "این فیلد ضروری است"],
      ncRules: [
        v => !!v || "این فیلد ضروری است",
        v => (v && v.length >= 3) || "حداقل 3 رقم"
      ],
      nameRules: [
        v => !!v || "نام و نام خانوادگی الزامی میباشد",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      nameclass: [
        v => !!v || "کلاس مورد نظر را مشخص کنید",
        v => (v && v.length >= 3) || "حداقل 3 کاراکتر"
      ],
      userTelRules: [
        v => !!v || "تلفن همراه الزامی میباشد",
        v => (v && v.length == 10) || "تلفن همراه وارد شده صحیح نمیباشد"
      ],
      userEmailRules: [
        v => !!v || "پست الکترونیکی الزامی میباشد",
        v => /.+@.+/.test(v) || "پست الکترونیکی وارد شده صحیح نمیباشد"
      ],
      userNameRules: [
        v => !!v || "نام کاربری الزامی میباشد",
        v => (v && v.length >= 5) || "نام کاربری باید حد اقل 5 کاراکتر باشد",
        v => /[A-Za-z&0-9]/.test(v) || "نام کاربری وارد شده صحیح نمیباشد"
      ],
      userPermissionRules: [v => !!v || "تعیین دسترسی های کاربر الزامی میباشد"],
      typereffer: ["داور خطا", "داور صحیح", "داور زمان"]
    };
  },
  methods: {
    onFileChanged(event) {
      this.User.image = event.target.files[0];
    },
    async getAllEnabled() {
      this.enabledUsers = (await AgentService.index()).data;
    },
    async create(user) {
      let res;
      var msg = "";
      this.error = null;
      const areAllFieldsFilledIn = Object.keys(this.User).every(
        key => !!this.User[key]
      );
      if (!areAllFieldsFilledIn) {
        this.error = "لطفا تمامی فیلد هارا پر کنید";
        return;
      }
      try {
        let formData = new FormData();
        formData.append("image", user.image);
        // user.image = formData
        let body = {
          name: user.name,
          no: user.no,
          codeMelli: user.codeMelli,
          phone: user.phone,
          email: user.email,
          username: user.username,
          password: user.password,
          image: formData,
          nfcCount: user.nfcCount,
          startNumber: user.startNumber,
          endNumber: user.endNumber
        };

        let res = await AgentService.post(user);
        console.log(res);
        if (res == 1) {
          msg = "=>DONE";
        } else if (res == 0) {
          msg = "=>FAILED";
        }
        console.log(msg);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.danger-alert {
  color: red;
}
.margin-top-50px {
  margin-top: 50px;
}
.bt {
  height: 48px;
  margin: 0;
  width: 100%;
}
</style>
